import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import forestRiverLogo from '../images/unified/forest-river-logo.png'
import Media from './Media'
import DropdownOpenTray from './DropdownOpenTray'
import '../styles/UnifiedHeader.scss'

const mobileDropdownItemShape = PropTypes.shape({
  label: PropTypes.string.isRequired,
  to: PropTypes.string,
  href: PropTypes.string,
  onClick: PropTypes.func,
  isCurrent: PropTypes.bool,
  isLabelOnly: PropTypes.bool,
})

export default function UnifiedHeader({ breadcrumb, mobileDropdown, actions, className, onLogoClick }) {
  const logo = <img src={forestRiverLogo} alt="" width="256" height="46" />

  return (
    <header className={classNames('UnifiedHeader', actions && 'UnifiedHeader--withActions', className)}>
      <div className="UnifiedHeader-inner">
        {onLogoClick ? (
          <button
            type="button"
            className="UnifiedHeader-logo"
            onClick={onLogoClick}
            aria-label="Forest River home"
          >
            {logo}
          </button>
        ) : (
          <span className="UnifiedHeader-logo UnifiedHeader-logo--static" aria-label="Forest River">
            {logo}
          </span>
        )}
        <Media type="desktop">
          {breadcrumb ? <div className="UnifiedHeader-breadcrumb">{breadcrumb}</div> : null}
        </Media>
        <Media type="mobile">
          {mobileDropdown ? <DropdownOpenTray {...mobileDropdown} /> : null}
        </Media>
        {actions ? <div className="UnifiedHeader-actions">{actions}</div> : null}
      </div>
    </header>
  )
}

UnifiedHeader.propTypes = {
  breadcrumb: PropTypes.node,
  mobileDropdown: PropTypes.shape({
    label: PropTypes.string.isRequired,
    items: PropTypes.arrayOf(mobileDropdownItemShape).isRequired,
    className: PropTypes.string,
    trayTitle: PropTypes.string,
    reverseItems: PropTypes.bool,
    showTrayHeader: PropTypes.bool,
    triggerVariant: PropTypes.oneOf(['text', 'pill', 'dots']),
  }),
  actions: PropTypes.node,
  className: PropTypes.string,
  onLogoClick: PropTypes.func,
}
